import React, { useContext, useState } from "react";
import { Context } from "../../utils/context";
import Cart from "./Cart";
import Checkout from "./Checkout";
import { Button, Steps } from "antd";
import { Box } from "@mui/material";
import PaymentSelection from "./CheckoutComponent/PaymentSelection";
const Index = () => {
  // const components = [<Cart />, <Checkout />, "Payment"];
  // const component = ["Cart", "Checkout", "Payment"];
  // const clipPathStyle = {
  //   clipPath: "polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%)",
  //   height: "50px", // Set your desired dimensions
  //   width: "200px", // Set your desired dimensions
  // };
  // const clipPathStyle2 = {
  //   clipPath: "polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%)",
  //   height: "50px", // Set your desired dimensions
  //   width: "200px",
  //   // Set your desired dimensions
  // };
  const [current, setCurrent] = useState(0);

  const items = [
    {
      title: "Cart",
      description: "",
      content: <Cart setCurrent={setCurrent} />,
    },
    {
      title: "Select Address",
      description: "",
      content: <Checkout setCurrent={setCurrent} />,
    },
    {
      title: "Payment",
      description: "",
      content: <PaymentSelection setCurrent={setCurrent} />,
    },
  ];
  return (
    <div className="min-h-screen" style={{ position: "relative" }}>
      {/* <div className="flex justify-center items-center gap-2  py-5 text-white font-bold">
        {component?.map((com, index) => (
          <h1
            key={index}
            style={page === index ? clipPathStyle2 : clipPathStyle}
            className={
              page === index
                ? "bg-[#FF8400] flex  justify-center items-center  "
                : "flex bg-gray-400  justify-center items-center bg-clip-border text-clip "
            }
          >
            {com}
          </h1>
        ))}
      </div> */}
      <div
        style={{
          backgroundColor: "white",
          position: "sticky",
          top: "70px",
          zindex: "100",
        }}
      >
        <Steps
          className="border-black w-4/5 py-5 text-white font-bold m-auto"
          current={current}
          items={items}
        />
      </div>

      {<div>{items[current].content}</div>}
      <Box
        style={{
          width: "full",
          margin: "15px 10px ",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "5px",
        }}
      >
        <Button
          disabled={current === 0}
          onClick={() => setCurrent(current - 1)}
        >
          Previous
        </Button>
        <Button
          disabled={current === 2}
          onClick={() => setCurrent(current + 1)}
        >
          Next
        </Button>
      </Box>
    </div>
  );
};

export default Index;
